import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.timeout = 360000;
// axios.defaults.baseURL = "/api/"
axios.defaults.baseURL = "/"


// POST传参序列化
axios.interceptors.request.use((config) => {
  return config;
}, (error) => {
  return Promise.reject(error);
});

//返回状态判断
axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  return Promise.reject(error);
});

export const h5 = params => {
  return axios.post(`web/consent`, params).then(response => response.data);
};
//获取页面数据
export const invite = params => {
  return axios.post(`web/invite`, params).then(response => response.data);
};

//获取传感器信息
export const productInfo = params => {
  return axios.get(`tool/sensor/info?id=${params}`).then(response => response.data);
};

//获取传感器信息
export const changeInfo = params => {
  return axios.get(`tool/sensor/logInfo?id=${params}`).then(response => response.data);
};

export const getSign = (url,sn) => {
  // url=${url}&
  // /api
  return axios.post(`/wechat/getWechatJSSDK`,{url: url,sn:sn}).then(response => response.data);
};

//判断是否是R3
export const imeiSn = params => {
  return axios.get(`web/getParentNumber?imeiSn=${params}`).then(response => response.data);
};




// WEBPACK FOOTER //
// ./src/api/api.js